import {ContentType} from 'sdk/src/defines';

const initialState = {
    contentTab: ContentType.CHANNEL,
};

const tabsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_CONTENT_TAB_SELECTED':
            return { ...state, contentTab: action.value };
        default:
            return state;
    }
};

export default tabsReducer;